// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2RpZw","legacyBtn":"MutateMid_legacyBtn__2A7u0"};